<template>
  <div class="app-pallets">
    <v-header v-bind:user="user" />
    <pallets-list :user="user" :selectable="true" :changeableStatus="true" />
  </div>
</template>

<script>
import VHeader from "../components/header";
import PalletsList from "../components/user/pallets/PalletsTable.vue";
import User from "@/models/User.js";

export default {
  data() {
    return {
      user: new User(this.$session.get("user")),
    };
  },
  created() {
    if (this.user.company_id == 9) {
      this.$session.destroy();
      this.$router.push("/login").catch(() => {});
    }
  },
  components: {
    VHeader,
    PalletsList,
  },
};
</script>
